export default (api) => ({
  fetch: (params) => api.$get("/configurations", { params }),

  fetchOne: (id) => api.$get(`/configurations/${id}`),

  update: (id, body) => api.$patch(`/configurations/${id}`, body),
});
